import React from 'react';
import { Row, Col, Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import classnames from 'classnames';
import './popover-style.css';

export const ChartDescriptorPopover = (props) => {
    
    return (
        <Popover className='popover-container' placement="bottom" isOpen={props.popoverOpen} target={props.targetId} toggle={props.toggle}>
            <PopoverHeader>{props.header}</PopoverHeader>
            <PopoverBody>
                {/* {props.body} */}
                <div  dangerouslySetInnerHTML={{ __html: props.body }}></div>
            </PopoverBody>
        </Popover>
    );
}
            
export default ChartDescriptorPopover;